export default "//yastatic.net/s3/distribution/pythia/frontend/_/faa4bd939ab4fa5e79340106373ff728.png";